import React from "react";
import PropTypes from "prop-types";

import styles from "./form-group.scss";

export default function FormGroup(props) {
    const { title, description, children, style } = props;
    return (
        <div className={styles.wrapper} style={style}>
            {title &&
                <div className={styles.title}>
                    <h3>{title}</h3>
                </div>
            }
            {description &&
                <div className={styles.description}>
                    <p>{description}</p>
                </div>
            }
            {children}
        </div>
    );
};

FormGroup.propTypes = {
    /**
     * Group title.
     */
    title: PropTypes.string,
    /**
     * Group description under the title.
     */
    description: PropTypes.string,
    /**
     * CSS styles to apply to wrapper.
     */
    style: PropTypes.object
};